import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../i18n/LanguageContext";

export default function HowItWorks() {
  const { t, copy } = useLanguage();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <section className="amgHowItWorks" id="how__it__works" data-aos="fade-up">
      <div className="amgHowItWorksInner">
        <p className="amgHowItWorksEyebrow">{t("how.eyebrow")}</p>
        <h2 className="amgHowItWorksHead">
          {t("how.headBefore")}
          <span className="amg-accent">{t("how.headAccent")}</span>
        </h2>
        <p className="amgHowItWorksLead">{t("how.lead")}</p>

        <ol className="amgHowItWorksSteps">
          {copy.how.steps.map((item) => (
            <li key={item.step} className="amgHowItWorksStep">
              <span className="amgHowItWorksStepNum" aria-hidden="true">
                {item.step}
              </span>
              <h3 className="amgHowItWorksStepTitle">{item.title}</h3>
              <p className="amgHowItWorksStepBody">{item.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
